import { getHostName } from "../utils";

export async function fetchHomeInfo(startDate, functionType) {
  const startDateString = JSON.stringify(startDate.toISOString());
  const data = await fetch(
    `${getHostName()}/api/homedata/?format=json&startdate=${startDateString}&functiontype=${functionType}`
  );
  return await data.json();
}
